var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancellIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.64,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42383 22.4731C9.00879 22.0664 9.02539 21.3608 9.41553 20.9707L14.3628 16.0151L9.41553 11.0679C9.02539 10.6777 9.01709 9.98047 9.42383 9.56543C9.83057 9.15039 10.5361 9.16699 10.9346 9.55713L15.8818 14.5044L20.8208 9.55713C21.2275 9.15039 21.9165 9.15869 22.3315 9.56543C22.7466 9.98047 22.7466 10.6694 22.3398 11.0762L17.4009 16.0151L22.3398 20.9624C22.7466 21.3691 22.7383 22.0581 22.3315 22.4731C21.9248 22.8882 21.2275 22.8882 20.8208 22.4814L15.8818 17.5342L10.9346 22.4814C10.5361 22.8716 9.83887 22.8882 9.42383 22.4731Z",
    fill: "#CCD1D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancellIcon);
export default __webpack_public_path__ + "static/media/cancell-icon.988945b236e59050f9e4ab964d60364d.svg";
export { ForwardRef as ReactComponent };